import createIcon from '../../createIcon';

/**
 * @component @name Crop
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTVIMTlWN0MxOSA1LjkgMTguMSA1IDE3IDVIOVY3SDE3VjE1Wk03IDE3VjFINVY1SDFWN0g1VjE3QzUgMTguMSA1LjkgMTkgNyAxOUgxN1YyM0gxOVYxOUgyM1YxN0g3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Crop = createIcon('Crop', [
  [
    'path',
    {
      d: 'M17 15H19V7C19 5.9 18.1 5 17 5H9V7H17V15ZM7 17V1H5V5H1V7H5V17C5 18.1 5.9 19 7 19H17V23H19V19H23V17H7Z',
      key: '1dmnxl',
    },
  ],
]);

export default Crop;
